import { Group, Stack, Text, Title } from "@mantine/core";
import type { JSX } from "react";
import { Link } from "react-router-dom";
import Loading from "../Loading";
import AttachModal from "./AttachModal";
import ChatInput from "./ChatInput";
import ForkButton from "./ForkButton";
import Personality from "./Personality";
import type { ThreadQuery } from "./queries";
import ThreadItem from "./ThreadItem";
import useThreadController from "./useThreadController";

interface IProps {
    thread: NonNullable<ThreadQuery["thread"]>;
}

function Thread({ thread }: IProps): JSX.Element {
    const {
        threadName,
        personality,
        setPersonality,
        threadItems,
        tokenCount,
        loadingText,
        isOwner,
        isSendingMessage,
        attachFetching,
        askAi,
        reAskAi,
        attachFile,
        attachKnowledge,
        attachTranscription,
        attachWebpage,
    } = useThreadController(thread);

    let interactArea = null;
    if (isOwner) {
        interactArea = (
            <>
                {loadingText ? <Loading text={loadingText} /> : <ChatInput askAi={askAi} sending={isSendingMessage} />}
                <Group justify="space-between">
                    <Text>Tokens: {tokenCount}</Text>
                    <Group>
                        <ForkButton thread={thread} />
                        <AttachModal
                            attachFile={attachFile}
                            attachFileFetching={attachFetching.file}
                            attachKnowledge={attachKnowledge}
                            attachKnowledgeFetching={attachFetching.knowledge}
                            attachWebpage={attachWebpage}
                            attachWebpageFetching={attachFetching.webpage}
                            attachTranscription={attachTranscription}
                            attachTranscriptionFetching={attachFetching.transcription}
                        />
                    </Group>
                </Group>
            </>
        );
    } else {
        interactArea = (
            <Group justify="space-between">
                <Text>Tokens: {tokenCount}</Text>
                <ForkButton thread={thread} />
            </Group>
        );
    }

    return (
        <>
            <Stack maw={800} mx="auto">
                <Title order={2}>{threadName || "New chat"}</Title>
                <Personality aiPersonality={personality} updatePersonality={setPersonality} />
                {threadItems.map((item) => (
                    <ThreadItem key={item.key} item={item} reAskAi={reAskAi} />
                ))}
                {interactArea}
            </Stack>
            <Link to="..">Back</Link>
        </>
    );
}

export default Thread;
